import { DatePipe } from '@angular/common';
import { Component, OnInit,ViewChild, ElementRef} from '@angular/core';
import { ModalController, PopoverController, ToastController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';
declare var google;
import { Geolocation } from '@ionic-native/geolocation/ngx';
import {DayConfig } from 'ion2-calendar';
import { CalendarComponentOptions } from 'ion2-calendar'
import { SuccessPage } from 'src/app/success/success.page';
import { ServicesProvider } from 'src/providers/services';
import { VideomodalPage } from '../videomodal/videomodal.page';


@Component({
  selector: 'app-viewmodel',
  templateUrl: './viewmodel.page.html',
  styleUrls: ['./viewmodel.page.scss'],
})
export class ViewmodelPage implements OnInit {
  @ViewChild('map', { static: false }) mapElement: ElementRef;
  From: any;
  dietHowToBooks:any;
  trainerHowToBook:any;
  trainerReschedule:any;
  rescheduleHeaderName:any;
  dateRange: any;
  month: any;
  year: any;
  duties: any;
  paragraph: any;
  excdat: any;
  sportsvender: any;
  showselectdate: any = [];
  diet_fromdate: any = [];
  diet_todate: any = "";
  diet_cheatdays: any = [];
  vendor: any
  workingHours: any;
  workingHoursHistory: any;
  showadress: any;
  selected_test: any;
  weekName: any;
  ecdays: {};
  showformated_date: any;
  workinghours: any;
  deliverytime: any;
  startdate_month: any;
  contactno: any;
  membername: [];
  memberidTT: [];
  memDetail: [];
  test: DayConfig[] = [
  ];
  explainervideo:any;
  explainervideoplay = false;


  weekdays: any = [
    { "value": this.addCall.title411, "is_checked": false,"days":"Sun" },
    { "value": this.addCall.title412, "is_checked": false,"days":"Mon" },
    { "value": this.addCall.title413, "is_checked": false,"days":"Tue" },
    { "value": this.addCall.title414, "is_checked": false,"days":"Wed" },
    { "value": this.addCall.title415, "is_checked": false,"days":"Thu" },
    { "value": this.addCall.title416, "is_checked": false,"days":"Fri" },
    { "value": this.addCall.title417, "is_checked": false,"days":"Sat" }
  ]
  cheat_days: any;
  cheat_day: any;
  DeliveryAddress: any
  delivery_contact_no: any
  delivery_instruction: any
  delivery_time: any;
  cc_code_details: any;
  cccode: any;
  map: any;
  latitude: number;
  longitude: number;
  address: string = '';
  presentView: string;
  // optionsMulti2:any;

  optionsMulti2: CalendarComponentOptions = {
    pickMode: 'multi'
  };
  // displayMode: 'month' = 'month';
  // defaultDate: string = '2024-06-01';
  // start: Date = new Date('2024-06-01');
  // end: Date = new Date('2024-06-30');
  // cheat_days :any;
  week_Name:any;
  storeDates:any;
  newstoreDates:any;
  menuid:any;
  vendorid:any;
  trainer_menuid:any;
  cheatnewstoreDates:any;
  fromDates:any;
  constructor(
    public modalCtrl: ModalController,
    public popoverCtrl: PopoverController,
    private datePipe: DatePipe,
    public addCall: AddCall,
    public geolocation: Geolocation,
    public toastCtrl: ToastController,
    private services: ServicesProvider,
  ) {
  }

  ngOnInit() {
    console.log("tom")
   }
  bindDates: any = [];

  ionViewWillEnter() {
    this.bindDates = [];
    if(this.dietHowToBooks == "dietexplainervideo" || this.trainerHowToBook == 'TrainerBook' || this.rescheduleHeaderName == 'RescheduleBooking'){
      this.getExplainerVideo(this.vendorid,this.menuid);
    }else if (this.From == "cheat_day") {
      let data = this.weekdays
      if (this.cheat_days != undefined && this.cheat_days != "") {
        this.cheat_days.map((obj) => {
          if (data[obj - 1]['is_checked'] != undefined) {
            data[obj - 1]['is_checked'] = true;
          }
        });
      }
      this.weekdays = data
    }
    else if (this.From == "delivery_address_update") {
      debugger
      this.deliverytime = this.delivery_time;
        this.contactno = this.delivery_contact_no;
        this.cccode = "+"+this.cc_code_details
    }
    else if (this.From == "weekRepeatOffModel") {
      this.week_Name = this.weekName;
    }
    else if (this.From == "fooddetails") {
      this.week_Name = this.weekName;
    }
    else if(this.From == "showdates" && this.vendor == "Diet"){
      debugger;
      if (this.showselectdate.length > 0) {
        this.fromDates = new Date(this.startdate_month);
        let setLabel = new Date(this.fromDates);
        let dateArray = String(setLabel).split(" ");
        this.year = dateArray[3];
        this.month = dateArray[1];
        this.getBkgDateCale(this.fromDates);
      }
    }
    else {
      this.showselectdate.forEach((item) => {
        this.bindDates.push(this.convertToShortYearFormat(item))
      })
    }
  }
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    };

    let formattedDate = date.toLocaleDateString('en-GB', options);

    // Replace spaces with hyphens and capitalize month abbreviation
    formattedDate = formattedDate
      .replace(/ /g, '-')      // Replace spaces with hyphens
      .replace(/-([a-z])/g, (match, p1) => `-${p1.toUpperCase()}`); // Capitalize month abbreviation

    return formattedDate;
  
}
monthsInArabic = {
  'Jan': 'يناير',
  'Feb': 'فبراير',
  'Mar': 'مارس',
  'Apr': 'أبريل',
  'May': 'مايو',
  'Jun': 'يونيو',
  'Jul': 'يوليو',
  'Aug': 'أغسطس',
  'Sep': 'سبتمبر',
  'Oct': 'أكتوبر',
  'Nov': 'نوفمبر',
  'Dec': 'ديسمبر'
};
getTranslatedMonth() {
  if (this.addCall.selectedLanguage === 'ea') {
    this.month = this.monthsInArabic[this.month];
  }
  // return this.month;
}
async OpenMapMethod(from : any) {
  const modal = await this.modalCtrl.create({
    component: SuccessPage,
    cssClass: 'mapmodel',
    componentProps: {
      Diet_from: from,
    }
  });
  modal.onDidDismiss()
  .then((data) => {
    debugger
    if (data.data == "success") {
       this.DeliveryAddress = data.role;
    }
  });
  return await modal.present();
}


getExplainerVideo(vendor_id,menu_id) {
  debugger
  let apiData = JSON.stringify({
    vendorid : vendor_id,
    menuid : menu_id
  });
  this.services
    .postRequest2("getClickMemberExpainervideo", apiData)
    .subscribe((res) => {
      console.log('mediaDetails=>', res);
      this.explainervideo = res.data
      console.log(this.explainervideo.length,"explainervideo")
    });
}
addVideoClose(){
  this.modalCtrl.dismiss({
    dismissed: true, 
  });
}
async playexplainervideo(video_play){
  console.log("video_play",video_play)
  const dietvideo = await this.modalCtrl.create({
    component: VideomodalPage,
    cssClass: 'fullpagevideoplay',
    backdropDismiss: false,
    componentProps: {
      videoplayer_name: video_play,
    },
  });
  await dietvideo.present();
}

  // getBkgDateCale(fromDate) {
  //   debugger;
  //   this.storeDates = [];
  //   this.newstoreDates = [];
  //   this.cheatnewstoreDates = [];
  //   const FromDate = new Date(fromDate);
  //   let exStatus = false;
  //   let newexStatus = false;
  //   let cheatnewexStatus = false;

  //   let prevDate = new Date(FromDate.getFullYear(), FromDate.getMonth(), 0).getDay();
  //   console.log("prevDate", prevDate);
  //   if (prevDate < 6) {
  //     for (let i = prevDate; i >= 0; i--) {
  //       this.storeDates.push({
  //         fullDate: " ",
  //         year: " ",
  //         month: " ",
  //         date: " ",
  //         excldDate: exStatus
  //       });
  //       this.newstoreDates.push({
  //         fullDate: " ",
  //         year: " ",
  //         month: " ",
  //         date: " ",
  //         excludedDates_available: newexStatus
  //       });
  //       this.cheatnewstoreDates.push({
  //         fullDate: " ",
  //         year: " ",
  //         month: " ",
  //         date: " ",
  //         excludedDates_cheatdays: cheatnewexStatus
  //       });
  //     }
  //   }
  //   console.log("?joy", this.storeDates);

  //   let monthEnd = new Date(FromDate.getFullYear(), FromDate.getMonth() + 1, 0).getDate();
  //   console.log("monthEnd=>", monthEnd);
  //   for (let i = 1; i <= monthEnd; i++) {
  //     for (let item of this.showselectdate) {
  //       let eD = new Date(item);
  //       let exDate = new Date(eD.getFullYear(), eD.getMonth(), eD.getDate()).toDateString();
  //       let date = new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString();
  //       if (exDate == date) {
  //         exStatus = true;
  //         break;
  //       }
  //       else {
  //         exStatus = false;
  //       }
  //     }
  //     for (let item of this.diet_fromdate) {
  //       let eD = new Date(item);
  //       let exDate = new Date(eD.getFullYear(), eD.getMonth(), eD.getDate()).toDateString();
  //       let date = new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString();
  //       if (exDate == date) {
  //         newexStatus = true;
  //         break;
  //       }
  //       else {
  //         newexStatus = false;
  //       }
  //     }

  //     for (let item of this.diet_cheatdays) {
  //       let eD = new Date(item);
  //       let exDate = new Date(eD.getFullYear(), eD.getMonth(), eD.getDate()).toDateString();
  //       let date = new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString();
  //       if (exDate == date) {
  //         cheatnewexStatus = true;
  //         break;
  //       }
  //       else {
  //         cheatnewexStatus = false;
  //       }
  //     }
  //     this.storeDates.push({
  //       fullDate: new Date(FromDate.getFullYear(), FromDate.getMonth(), i),
  //       year: FromDate.getFullYear(),
  //       month: FromDate.getMonth() + 1,
  //       date: i,
  //       excldDate: exStatus,
  //       excludedDates_available: newexStatus,
  //       excludedDates_cheatdays: cheatnewexStatus
  //     });
  //     exStatus = false;
  //   }
  //   console.log("storeDate=>", this.newstoreDates);
  //   this.getTranslatedMonth();
  // }

  async getBkgDateCale(fromDate) {
    // Resetting the data arrays
    console.log("this.diet_fromdate this.diet_fromdate", this.diet_fromdate)
    console.log("fromDatefromDate",fromDate)
    this.storeDates = [];
    this.newstoreDates = [];
    this.cheatnewstoreDates = [];

    const FromDate = new Date(fromDate);
    let exStatus = false;
    let newexStatus = false;
    let cheatnewexStatus = false;
    let dayName = "";

    // Initialize cheat days if not defined
    if (!this.diet_cheatdays || this.diet_cheatdays.length === 0) {
      console.warn("Cheat days are not initialized.");
      this.diet_cheatdays = []; // Set a default or handle as per your use case
    }

    let prevDate = new Date(FromDate.getFullYear(), FromDate.getMonth(), 0).getDay();
    console.log("prevDate", prevDate);

    // Handling previous month days (empty slots)
    if (prevDate < 6) {
      for (let i = prevDate; i >= 0; i--) {
        this.storeDates.push({
          fullDate: " ",
          year: " ",
          month: " ",
          date: " ",
          excldDate: exStatus
        });
        this.newstoreDates.push({
          fullDate: " ",
          year: " ",
          month: " ",
          date: " ",
          excludedDates_available: newexStatus
        });
        this.cheatnewstoreDates.push({
          fullDate: " ",
          year: " ",
          month: " ",
          date: " ",
          excludedDates_cheatdays: cheatnewexStatus
        });
      }
    }
    console.log("?joy", this.storeDates);


    let monthEnd = new Date(FromDate.getFullYear(), FromDate.getMonth() + 1, 0).getDate();
    console.log("monthEnd=>", monthEnd);

    // Loop through the month days and fill storeDates, newstoreDates, cheatnewstoreDates
    for (let i = 1; i <= monthEnd; i++) {
      // Checking for excluded dates
      for (let item of this.showselectdate) {
        let eD = new Date(item);
        let exDate = new Date(eD.getFullYear(), eD.getMonth(), eD.getDate()).toDateString();
        let date = new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString();
        if (exDate == date) {
          exStatus = true;
          break;
        } else {
          exStatus = false;
        }
      }

      // Checking for available dates
      for (let item of this.diet_fromdate) {
        let eD = new Date(item);
        let exDate = new Date(eD.getFullYear(), eD.getMonth(), eD.getDate()).toDateString();
        let date = new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString();
        if (exDate == date) {
          newexStatus = true;
          break;
        } else {
          newexStatus = false;
        }
      }

          // Handle cheat days logic
      // const today = new Date() + 1;
      const today = new Date(this.diet_fromdate[0]);
      // const tomorrow = new Date(today);
      // tomorrow.setDate(today.getDate() + 1);
      today.setHours(0, 0, 0, 0); // Reset time to 00:00:00 for accurate comparison
      const fromDateOnly = new Date(FromDate.getFullYear(), FromDate.getMonth(), i);
      const isFutureDate = fromDateOnly >= today;


      // Get the weekday name (abbreviated)
      dayName = new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toLocaleString('en-us', { weekday: 'short' });
      const lastDietDate = new Date(this.diet_fromdate[this.diet_fromdate.length - 1]);


      // If the date is in the future, check for cheat days
      // cheatnewexStatus = isFutureDate ? this.diet_cheatdays.flatMap((dayString: string) =>
      //   dayString.split(",").map((day: string) => day.trim())
      // ).includes(dayName) : false;

      cheatnewexStatus = isFutureDate && fromDateOnly <= lastDietDate
      ? this.diet_cheatdays.flatMap((dayString) =>
          dayString.split(",").map((day) => day.trim())
        ).includes(dayName)
      : false;



      // Push the results for the current day
      this.storeDates.push({
        fullDate: new Date(FromDate.getFullYear(), FromDate.getMonth(), i),
        year: FromDate.getFullYear(),
        month: FromDate.getMonth() + 1,
        date: i,
        excldDate: exStatus,
        excludedDates_available: newexStatus,
        excludedDates_cheatdays: cheatnewexStatus
      });

      // Reset status for the next iteration
      exStatus = false;
    }

    // Log the result for debugging
    console.log("Store Dates:", this.storeDates);

    // Fetch translated month or any other action
    this.getTranslatedMonth();
  }

  // next() {
  //   debugger;
  //     let nextMonth = new Date(this.fromDates.getFullYear(), this.fromDates.getMonth() + 1, 1);
  //     let dateArrayd = String(nextMonth).split(" ");
  //     const distinctMonths = [...new Set(this.diet_fromdate.map(date => date.split('-')[1]))];
  //     var check  = distinctMonths.includes(dateArrayd[1])
  //     if(check){
  //       let dateArray = String(nextMonth).split(" ");
  //       this.year = dateArray[3];
  //       this.month = dateArray[1];
  //     console.log("nextMonth", nextMonth);
  //     this.fromDates = nextMonth;
  //     this.getBkgDateCale(new Date(nextMonth));
  //     }
  // }
  // prev() {
  //   let nextMonth = new Date(this.fromDates.getFullYear(), this.fromDates.getMonth() - 1, 1);
  //     let dateArrayd = String(nextMonth).split(" ");

  //     const distinctMonths = [...new Set(this.diet_fromdate.map(date => date.split('-')[1]))];
  //     var check  = distinctMonths.includes(dateArrayd[1])
  //     if(check){
  //     console.log("nextMonth", nextMonth);
  //     let dateArray = String(nextMonth).split(" ");
  //     this.year = dateArray[3];
  //     this.month = dateArray[1];
  //     this.fromDates = nextMonth;
  //     this.getBkgDateCale(new Date(nextMonth));
  //     }
  // }

  next() {
    const combinedDates = [...new Set([...this.diet_fromdate, ...this.showselectdate])];
    const combinedMonthsYears = combinedDates.map(date => {
      const [day, month, year] = date.split('-');
      return { month, year };
    });
    console.log("Combined Months and Years:", combinedMonthsYears);

    // Get the next month's year and month from `this.fromDates`
    let nextMonth = new Date(this.fromDates.getFullYear(), this.fromDates.getMonth() + 1, 1);
    let nextMonthStr = nextMonth.toLocaleString("en-US", { month: "short" });
    let nextMonthYear = nextMonth.getFullYear().toString();

    // Check if `nextMonth` exists in the combined months and years
    const isValidMonth = combinedMonthsYears.some(item => {
      return item.month === nextMonthStr && item.year === nextMonthYear;
    });
    console.log("Is Valid Month:", isValidMonth);

    // If valid, update `this.fromDates` and proceed
    if (isValidMonth) {
      this.fromDates = nextMonth;
      const dateArray = String(nextMonth).split(" ");
      this.year = dateArray[3]; // Extract year
      this.month = dateArray[1]; // Extract month (e.g., "Dec")

      // Call `getBkgDateCale` with the updated month
      this.getBkgDateCale(new Date(nextMonth));
    } else {
      console.log("Next month is not in the allowed range of combined dates.");
    }
  }

  prev() {
    console.log("this.fromDates", this.fromDates);

    // Combine `diet_fromdate` and `showselectdate`
    const combinedDates = [...new Set([...this.diet_fromdate, ...this.showselectdate])];
    console.log("Combined Dates:", combinedDates);

    // Extract unique months and years from the combined dates
    const combinedMonthsYears = combinedDates.map(date => {
      const [day, month, year] = date.split('-');
      return { month, year };
    });
    console.log("Combined Months and Years:", combinedMonthsYears);

    // Get the previous month's year and month from `this.fromDates`
    let prevMonth = new Date(this.fromDates.getFullYear(), this.fromDates.getMonth() - 1, 1);
    let prevMonthStr = prevMonth.toLocaleString("en-US", { month: "short" });
    let prevMonthYear = prevMonth.getFullYear().toString();

    // Check if `prevMonth` exists in the combined months and years
    const isValidMonth = combinedMonthsYears.some(item => {
      return item.month === prevMonthStr && item.year === prevMonthYear;
    });
    console.log("Is Valid Month:", isValidMonth);

    // If valid, update `this.fromDates` and proceed
    if (isValidMonth) {
      this.fromDates = prevMonth;
      const dateArray = String(prevMonth).split(" ");
      this.year = dateArray[3]; // Extract year
      this.month = dateArray[1]; // Extract month (e.g., "Dec")
      console.log("Valid prevMonth:", prevMonth);

      // Call `getBkgDateCale` with the updated month
      this.getBkgDateCale(new Date(prevMonth));
    } else {
      console.log("Previous month is not in the allowed range of combined dates.");
    }
  }

  async presentToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }
  convertToShortYearFormat(dateString) {
    let parts = dateString.split("-");
    let monthAbbreviations = {
      "01": "Jan", "02": "Feb", "03": "Mar", "04": "Apr", "05": "May", "06": "Jun",
      "07": "Jul", "08": "Aug", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dec"
    };
    let monthAbbreviation = monthAbbreviations[parts[1]];
    let formattedDate = parts[0] + "-" + monthAbbreviation + "-" + parts[2].substring(2);
    return formattedDate;

  }
  dismiss() {

    this.popoverCtrl.dismiss();

    // Dismiss the popover with the data
    this.modalCtrl.dismiss(this.membername);


  }


  getFormattedDateTime(dateTime) {

    if (!dateTime) {
      return "";
    }

    let Value;

    if (dateTime.indexOf("T") > -1) {
      Value = dateTime.split("T")[1];
    } else if (dateTime.indexOf(" ") > -1) {
      Value = dateTime.split(" ")[1];
    } else {
      Value = dateTime;
    }
    let hourEnd = Value.indexOf(":");
    let H = +String(Value).substr(0, hourEnd);
    let h = H % 12 || 12;
    let ampm = (H < 12 || H === 24) ? "AM" : "PM";
    let hr = (h < 12 && (h.toString().length == 1)) ? "0" + h : h;
    let timeString = hr + String(Value).substr(hourEnd, 3) + " " + ampm;
    return timeString;

  }

  convertDateFormat(originalDate) {
    // Create a Date object from the original date string
    const dateObject = new Date(originalDate);

    // Format the date as "DD-MMMYY"
    const formattedDate = `${this.padZero(dateObject.getDate())}-${this.getMonthAbbreviation(dateObject.getMonth())}-${String(dateObject.getFullYear()).slice(-2)}`;

    return formattedDate;
  }

  getMonthAbbreviation(monthIndex) {
    const monthsAbbreviation = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return monthsAbbreviation[monthIndex];
  }

  padZero(num) {
    return num.toString().padStart(2, '0');
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }
  removeSelectMem(index: number): void {
    if (index >= 0 && index < this.membername.length) {
      // Use splice to remove the element at the specified index
      this.membername.splice(index, 1);
      this.memberidTT.splice(index, 1)
      this.memDetail.splice(index, 1)
      console.log(this.membername, "ssssssssssssssss=");
      console.log(this.memberidTT, "ssssssssssssssss=");

    }
  }

  cheatDaySubmit(type) {
    let checkday_arr: any = [];
    let obj = {
      day: "",
      days: ""
    };
    if (type == 0) {
      obj.day = '0';
        obj.days = "Skip";
      checkday_arr.push(obj);
      this.cheat_day = checkday_arr;
      this.modalCtrl.dismiss('', this.cheat_day)
    }
    else {

      // Dismiss the popover with the data
      let weekday_arr = [];


      this.weekdays.map((obj, i) => {
        if (obj['is_checked']) {
          obj.day = i + 1;
          checkday_arr.push(obj);
          weekday_arr.push(i + 1)
        }
      })
      this.cheat_days = checkday_arr
      if (this.cheat_days.length != 0 && this.cheat_days.length != 7) {
        debugger
        this.modalCtrl.dismiss(this.cheat_days, checkday_arr);
      }
      else if(this.cheat_days.length == 7){
      }
      else {
        this.presentToast(this.addCall.title660);

      }
    }

  }

  selectAndSaveLater(type) {

    if (type == 0) {
      this.modalCtrl.dismiss('BookConfirmPage');
    } else {
      this.modalCtrl.dismiss('Cancel');
    }
  }

  isSaveAndSelectLater(type) {
    if (type == 0) {
      this.modalCtrl.dismiss('Cancel');
    }
  }

  weekRepeatOffModel(type) {
    if (type == 0) {
      this.modalCtrl.dismiss('Cancel');
    }
  }

  getAddress() {
    this.geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 5000
    }).then((resp) => {

      this.getReverseGeocodingData(resp.coords.latitude, resp.coords.longitude)
    }, err => {

    });
  }


  getReverseGeocodingData(latitude, longitude) {
    let latlng = new google.maps.LatLng(latitude, longitude);
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'latLng': latlng }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        console.error('Geocoding request failed with status:', status);
      } else {
        if (results && results.length > 0) {
          this.DeliveryAddress = results[0].formatted_address;
        } else {
          console.error('No results found');
        }
      }
    });
  }



  dismissAddress() {
    this.modalCtrl.dismiss();
  }

  dismissstartdate() {
    this.modalCtrl.dismiss();
  }

  submitAddress() {
    let data = {
      "DeliveryAddress": this.DeliveryAddress,
      "delivery_contact_no": this.delivery_contact_no,
      "delivery_instruction": this.delivery_instruction
    }
    this.modalCtrl.dismiss(data);
  }

}
